import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BLACK_700, Typography, getTestId } from '@airtel/air-design-system';
import { View } from 'react-native';
import { ButtonWidget } from '../../../button-widget';
import PackInfo from '../../../order-summary-card-widget/components/pack-info/PackInfo';
import { TEXT_TYPE } from '../../InfoSummaryWidgetConstants';
import { getKeyBenefitsSectionTabStyles } from './KeyBenefitsSectionTabStyles';
export var KeyBenefitsSectionTab = props => {
  var _a;
  var singleCardDetails = props.singleCardDetails,
    isMobileScreen = props.isMobileScreen,
    onUserAction = props.onUserAction;
  var _singleCardDetails$sh = singleCardDetails.showKeyBenefitsSection,
    showKeyBenefitsSection = _singleCardDetails$sh === void 0 ? false : _singleCardDetails$sh;
  var keyBenefitsSectionStyles = getKeyBenefitsSectionTabStyles();
  if (!showKeyBenefitsSection) {
    return _jsx(_Fragment, {});
  }
  return (!!(singleCardDetails === null || singleCardDetails === void 0 ? void 0 : singleCardDetails.viewDetailsCTAProps) || !!(singleCardDetails === null || singleCardDetails === void 0 ? void 0 : singleCardDetails.additionalBenefits) || !!(singleCardDetails === null || singleCardDetails === void 0 ? void 0 : singleCardDetails.footerText)) && _jsxs(View, Object.assign({
    style: keyBenefitsSectionStyles === null || keyBenefitsSectionStyles === void 0 ? void 0 : keyBenefitsSectionStyles.keyBenefitsSection
  }, {
    children: [_jsxs(View, Object.assign({
      style: [keyBenefitsSectionStyles === null || keyBenefitsSectionStyles === void 0 ? void 0 : keyBenefitsSectionStyles.headerWrapper, !(singleCardDetails === null || singleCardDetails === void 0 ? void 0 : singleCardDetails.footerText) && (keyBenefitsSectionStyles === null || keyBenefitsSectionStyles === void 0 ? void 0 : keyBenefitsSectionStyles.headerWrapperNullStartElement)]
    }, {
      children: [!!(singleCardDetails === null || singleCardDetails === void 0 ? void 0 : singleCardDetails.footerText) && _jsx(View, {
        children: _jsx(Typography, Object.assign({
          text: singleCardDetails === null || singleCardDetails === void 0 ? void 0 : singleCardDetails.footerText,
          type: isMobileScreen ? TEXT_TYPE.BODY_PARA_XS : TEXT_TYPE.BODY_PARA_SM,
          color: BLACK_700
        }, getTestId(props === null || props === void 0 ? void 0 : props.testID, 'footerText')))
      }), !!(singleCardDetails === null || singleCardDetails === void 0 ? void 0 : singleCardDetails.viewDetailsCTAProps) && _jsx(View, Object.assign({
        style: keyBenefitsSectionStyles === null || keyBenefitsSectionStyles === void 0 ? void 0 : keyBenefitsSectionStyles.headerOneInfoCTAWrapper
      }, {
        children: _jsx(ButtonWidget, Object.assign({
          leftCta: Object.assign({
            testID: props === null || props === void 0 ? void 0 : props.testID
          }, singleCardDetails === null || singleCardDetails === void 0 ? void 0 : singleCardDetails.viewDetailsCTAProps),
          onLeftCtaPress: (_a = singleCardDetails === null || singleCardDetails === void 0 ? void 0 : singleCardDetails.viewDetailsCTAProps) === null || _a === void 0 ? void 0 : _a.onLeftCtaPress,
          onUserAction: onUserAction
        }, getTestId(props === null || props === void 0 ? void 0 : props.testID, 'viewDetailsCTAProps')))
      }))]
    })), !!(singleCardDetails === null || singleCardDetails === void 0 ? void 0 : singleCardDetails.additionalBenefits) && _jsx(View, {
      children: _jsx(PackInfo, Object.assign({
        additionalBenefits: singleCardDetails === null || singleCardDetails === void 0 ? void 0 : singleCardDetails.additionalBenefits
      }, getTestId(props === null || props === void 0 ? void 0 : props.testID, 'additionalBenefits')))
    })]
  }));
};
export default KeyBenefitsSectionTab;